import { Component } from '@angular/core';

@Component({
  selector: 'app-required-field-note',
  templateUrl: './required-field-note.component.html',
  standalone: false,
})
export class RequiredFieldNoteComponent {}
